import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied-screen',
  template: `
    <div style="width: 100%; height: 100%; color: #f3f3f3;" class="vertical layout center middle">
      <mat-icon style="font-size: 200px; width: 200px; height: 200px;">security</mat-icon>
      <div style="font-size: 80px; margin-top: 40px;">FORBIDDEN</div>
    </div>
  `,
  styles: []
})
export class AccessDeniedScreenComponent {

  constructor() { }

}
